var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as SvgIcons from "../SvgIcons";
import { FileQuestion, FileVideo } from "mdi-material-ui";
function CardMediaThumbnail(_a) {
    var _b;
    var { thumbnail, url, style = {} } = _a, props = __rest(_a, ["thumbnail", "url", "style"]);
    const renderImage = (url) => _jsx("img", Object.assign({ style: Object.assign(Object.assign({}, style), { verticalAlign: "middle", objectFit: "contain" }) }, props, { alt: url, src: url }));
    if (thumbnail)
        return renderImage(thumbnail);
    const fileType = (_b = url.split("?")[0].split('.').pop()) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase();
    let CustomIcon;
    switch (fileType) {
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
        case "jfif":
            return renderImage(url);
        case "xlsx":
        case "xls":
            CustomIcon = SvgIcons.ExcelIcon;
            break;
        case "mp4":
        case "mov":
        case "wmv":
        case "avi":
        case "webm":
            CustomIcon = FileVideo;
            break;
        case "pdf":
            CustomIcon = SvgIcons.PdfIcon;
            break;
        default:
            CustomIcon = FileQuestion;
    }
    return _jsx(CustomIcon, Object.assign({}, props, { style: style }));
}
export default CardMediaThumbnail;
